var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._b({attrs:{"left":_vm.left}},'v-avatar',{size: _vm.avatarSize, color: _vm.avatarColor},false),[_c('v-icon',_vm._b({},'v-icon',{size: _vm.iconSize, color: _vm.iconColor},false),[_vm._v("mdi-account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }